import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { GetFeedQueryVariables } from 'api';
import { useGetFeed, useNotify } from 'hooks';
import { EmptyState } from 'components';
import { SmallSection, MediumSection, GridSectionTitle } from 'features/feed';
import { generateLink } from 'Links';

interface Props {
  last?: boolean;
  groupOptions: {
    title: string;
    variables: GetFeedQueryVariables;
  };
}

const useStyles = makeStyles(theme => ({
  divider: {
    margin: theme.spacing(8, 0, 3, 0),
  },
}));

const GridTimelineGroup: FC<Props> = ({ groupOptions, last }) => {
  const { title, variables } = groupOptions || {};

  const classes = useStyles();
  const notify = useNotify();
  const { t } = useTranslation();
  const { results, isInitialLoad } = useGetFeed(variables, {
    onError: notify.queryError,
    enabled: !!variables && !!title,
  });

  let layout = null;

  if (isInitialLoad) {
    return null;
  }

  function renderEmptyState() {
    if (!groupOptions?.variables?.id) {
      return null;
    }

    return (
      <EmptyState
        box
        name="groupMember"
        actionComponent={
          <Box paddingTop={2}>
            <Button
              component={generateLink(`/group/${variables.id}`)}
              color="primary"
              variant="contained"
              size="large"
            >
              {t('emptyStates:groupMemberAction')}
            </Button>
          </Box>
        }
      />
    );
  }

  switch (results.length) {
    case 0:
      return renderEmptyState();
    case 1:
      layout = <MediumSection results={results} indexes={[0]} />;
      break;
    case 2:
      layout = <MediumSection results={results} indexes={[0, 1]} />;
      break;
    case 3:
    default:
      layout = <SmallSection results={results} indexes={[0, 1, 2]} />;
  }

  return (
    <Fragment>
      <GridSectionTitle title={title} />
      {layout}
      {!last && <Divider className={classes.divider} />}
    </Fragment>
  );
};

GridTimelineGroup.defaultProps = {
  last: false,
};

export default GridTimelineGroup;
